<template>
  <li
    data-grid="center-center"
    :class="additionalClasses"
    class="tabitem p-relative h-100 cursor-pointer text-uppercase"
    @click.prevent="followDestiny"
  >
    <slot>
      {{ label }}
    </slot>
  </li>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TabItem',

  props: {
    routerName: {
      type: String,
      required: true
    },

    label: {
      type: String,
      required: true
    }
  },

  computed: {
    destiny () {
      return {
        name: this.routerName,
        query: {
          ...this.$route.query
        }
      }
    },

    additionalClasses () {
      return {
        'tabitem--active': this.$route.name === this.routerName
      }
    }
  },

  methods: {
    followDestiny () {
      this.$router.push(this.destiny)
    }
  }
})
</script>

<style lang="scss" scoped>
  .tabitem {
    min-height: auto;
    width: max-content;
    letter-spacing: .1rem;
    color: rgb(var(--gray12));
    font: 700 1.4rem / 1.8rem "Nunito", sans-serif;

    &:after {
      content: '';

      bottom: 0;
      position: absolute;
      border-radius: 8px;
      width: 100%;
      height: 4px;
      opacity: 0;
      transform: scale(.85);
      transition: all .2s ease-in-out;
      background-color: var(--primary);
    }

    &--active {
      color: var(--primary);

      &:after {
        opacity: 1;
        transform: scale(1);
      }
    }
  }
</style>
